import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { KpmgTaxUiModule } from "@kpmg-tax/ui";
import { AuthPolicyService } from "./auth";
import { AdminMenuComponent } from "./menus/admin-menu";
import { AppContextStore } from "./services";
import { AuthorizationService } from "./auth/authorization.service";
import { InfoMenuComponent } from "./menus/info-menu/info-menu.component";
import { MaxNumberDirective } from "./directives/maxnumber.directive";

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, KpmgTaxUiModule],
    declarations: [AdminMenuComponent, InfoMenuComponent, MaxNumberDirective],
    providers: [AuthPolicyService, AuthorizationService, AppContextStore],
    exports: [AdminMenuComponent, InfoMenuComponent, MaxNumberDirective],
    entryComponents: [AdminMenuComponent, InfoMenuComponent], // This is needed for AppToolbar widget injection
})
export class CoreModule {}